import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';

// A chosen value as a settled row: the value, a line of detail under it, and the way to change it
@Component({
  selector   : 'wor-booking-diary-selected',
  template: require('./booking-diary.selected.component.html')
})
export class BookingDiarySelectedComponent {
  @Output() changeRequested : EventEmitter<void> = new EventEmitter<void>();
}
